
export namespace CSProcessGuidelineDocConst {
  export enum CSProcessGuidelineEnumType {
    CS_PROCESS = 'CS_PROCESS',
    CS_INTERNAL_GUIDANCE = 'CS_INTERNAL_GUIDANCE'
  }
}